import { type DependencyList, type EffectCallback, useEffect as useReactEffect } from "react";
import { RemiErrorDeprecated } from "@remi/error";
import { remiLogger } from "@remi/logging";

import { useDebugMode } from "./useDebugMode";

export const useEffect = (effect: EffectCallback, dependencyList?: DependencyList) => {
  const debugMode = useDebugMode();
  const errorStack = new RemiErrorDeprecated({ message: "Replace with appropriate message" }).stack
    ?.split("\n")[1]
    ?.trim()
    .split("/");
  const fileSuffix = errorStack?.[errorStack.length - 1];
  const fileName = fileSuffix?.split(":");
  fileName?.pop();
  return useReactEffect(() => {
    if (debugMode) {
      remiLogger.info("useEffect triggered.", { sourceFile: fileName?.join(":") });
    }
    return effect();
  }, dependencyList);
};
